module.exports = __webpack_public_path__ + "img/casas-administraciones-4.93a75775.jpg";